/** Upper bound for operator-configured minimum processing screen dwell (seconds). */
export const PRINT_RESULT_MIN_DISPLAY_MAX_SECONDS = 300

export interface WaitPrintResultMinDisplayOptions {
  isStillMounted: () => boolean
}

/**
 * After the print/upload pipeline finishes, hold the processing UI until at least
 * `minSeconds` have elapsed since `processingStartedAtMs` (wall clock).
 */
export async function waitPrintResultMinDisplay(
  processingStartedAtMs: number,
  minSeconds: number,
  options: WaitPrintResultMinDisplayOptions
): Promise<void> {
  if (minSeconds <= 0) return

  const remainingMs = minSeconds * 1000 - (Date.now() - processingStartedAtMs)
  if (remainingMs <= 0) return

  await new Promise<void>((resolve) => {
    const finish = (): void => {
      window.clearTimeout(timeoutId)
      window.clearInterval(pollId)
      resolve()
    }
    const timeoutId = window.setTimeout(finish, remainingMs)
    const pollId = window.setInterval(() => {
      if (!options.isStillMounted()) finish()
    }, 150)
  })
}
